/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/reduce */
import{scanInternals as t}from"rxjs/dist/esm/internal/operators/scanInternals";import{operate as n}from"rxjs/dist/esm/internal/util/lift";function m(r,e){return n(t(r,e,arguments.length>=2,!1,!0))}export{m as reduce};
//# sourceMappingURL=reduce.mjs.map